import { ROUTE } from "@/_old/constants/routes";
import { useLocation } from "react-router-dom";
import {
  EVENT_CATEGORIES,
  EVENTS_FILTER_BY_PAGE,
  EVENT_FILTER,
} from "../../constants/events";
import { useAnalytics } from "../../contexts/segment";

export const useChangeFilterTrack = () => {
  const { pathname } = useLocation();
  const { track } = useAnalytics();
  const onChangeFilter = (
    event: EVENT_FILTER,
    category: keyof typeof EVENT_CATEGORIES,
  ) => {
    if (EVENTS_FILTER_BY_PAGE[pathname as ROUTE]?.[event]) {
      track(EVENTS_FILTER_BY_PAGE[pathname as ROUTE]![event]!, {
        category: EVENT_CATEGORIES[category],
      });
    }
  };

  return { onChangeFilter };
};
